import { render, staticRenderFns } from "./PrivacyPolicy.vue?vue&type=template&id=0b62fd2a"
import script from "./PrivacyPolicy.vue?vue&type=script&lang=js"
export * from "./PrivacyPolicy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\BuildAgent\\work\\136\\s\\Yahome.RecruitSystem.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b62fd2a')) {
      api.createRecord('0b62fd2a', component.options)
    } else {
      api.reload('0b62fd2a', component.options)
    }
    module.hot.accept("./PrivacyPolicy.vue?vue&type=template&id=0b62fd2a", function () {
      api.rerender('0b62fd2a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/front/PrivacyPolicy.vue"
export default component.exports